/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    interface ICategorySelectize {
        text?: string;
        value?: string;
    }

    export interface ICategoryModalScope extends ng.IScope {
        allCategories: ICategorySelectize[];
        blockCategories: ICategorySelectize[];            
        modalClose: () => void;
        modalSave: () => void;
        loadSelectize: () => void;
        categoriesAsString: string;
    }

    /**
     * CategoryModalController class
     */
    export class CategoryModalController {
        public static templateUrl: string = "decorators/modals/category-modal.html";
        public static ID: string = "#id-category-modal";
        public static $name: string = "categoryModalController";
        public static $inject: string[] = ['$scope', 'close', '$timeout', 'blockCategories', 'allCategories'];

        private static SELECTIZE_ID: string = "#selectize-categories";
        private categoriesSelectize: Selectize.IApi<string, string>;
        private scope: ICategoryModalScope;
        private close: (result: Object) => void;

        /**
         * Constructor
         */
        constructor($scope: ICategoryModalScope,
                    close: () => void,
                    $timeout: ng.ITimeoutService,
                    blockCategories: Models.Category[],
                    allCategories: Models.Category[]) {

            $timeout(() => {
                window.altair_admin_common_init();
            }, 500);
            
            let originalCategories: string[] = [];
            blockCategories.forEach((category: Models.Category) => {
                originalCategories.push(category.name);
            });

            this.scope = $scope;
            this.scope.loadSelectize = () => {
                this.createCategoriesForSelectize(allCategories, blockCategories);
                this.loadCategoriesSelectize();
            };

            this.scope.modalSave = () => {
                let categoriesToAdd: string[] = this.categoriesSelectize.getValue().split(",").filter((category: string) => {
                    return originalCategories.indexOf(category) < 0;
                }).filter((category: string) => {
                    return category !== "";
                });

                let categoriesToDelete: string[] = originalCategories.filter((category: string) => {
                    return this.categoriesSelectize.getValue().split(",").indexOf(category) < 0;
                }).filter((category: string) => {
                    return category !== "";
                });
                
                this.close({
                    categoriesToAdd: categoriesToAdd,
                    categoriesToDelete: categoriesToDelete,    
                });
            };

            this.close = close;
            this.scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.scope.$on('$destroy', () => {
                if (this.categoriesSelectize)
                    this.categoriesSelectize.destroy();
            });
        }

        private loadCategoriesSelectize(): void {
            if (this.categoriesSelectize !== undefined)
                this.categoriesSelectize.destroy();
                
            let $select: JQuery = $(CategoryModalController.SELECTIZE_ID).selectize({
                plugins: {
                    'remove_button': {
                        label     : '',
                    },
                },
                delimiter: ',',
                persist: false,
                selectOnTab: true,
                create: function(newCategory: string): ICategorySelectize {
                    return {
                        value: newCategory,
                        text: newCategory,
                    };
                },
                options: this.scope.allCategories,
                render: {
                    option: function(data: ICategorySelectize, escape: (text: string) => void): string {
                        return  '<div class="option">' +
                                '<span class="title">' + escape(data.text) + '</span>' +
                                '</div>';
                    },
                    item: function(data: ICategorySelectize, escape: (text: string) => void): string {
                        return '<div class="">' + escape(data.text) + '</div>';
                    },
                },
                onDropdownOpen: function($dropdown: JQuery): void {
                    $dropdown
                        .hide()
                        .velocity('slideDown', {
                            begin: function(): void {
                                $dropdown.css({'margin-top': '0'});
                            },
                            duration: 200,
                        });
                },
                onDropdownClose: function($dropdown: JQuery): void {
                    $dropdown
                        .show()
                        .velocity('slideUp', {
                            complete: function(): void {
                                $dropdown.css({'margin-top': '0'});
                            },
                            duration: 200,
                        });
                },
            });
            this.categoriesSelectize = $select[0].selectize;
            this.scope.blockCategories.forEach((category: ICategorySelectize) => {
                this.categoriesSelectize.addItem(category.text);
            });
        }

        private createCategoriesForSelectize(allCategories: Models.Category[], blockCategories: Models.Category[]): void {
            this.scope.blockCategories = [];
            this.scope.allCategories = [];

            allCategories.forEach((category: Models.Category) => {
                if (category.name !== Models.BlocksFilter.UNCATEGORIZED)
                    this.scope.allCategories.push({
                        text: category.name,
                        value: category.name,
                    });
            });

            blockCategories.forEach((category: Models.Category) => { 
                if (category.name !== Models.BlocksFilter.UNCATEGORIZED)
                    this.scope.blockCategories.push({
                        text: category.name,
                        value: category.name,
                    });
            });
        }
    }
}
